import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './pages/Home';
import './styles/shared.scss';
import NavBar from './components/containers/NavBar';
import NitroStream from "./pages/NitroStream";
import NitroStream2 from "./pages/NitroStream2";
import Sideattack from "./pages/Sideattack";
import NitroStreamIgnition from "./pages/NitroStreamIgnition";
import BurninRubber3A from "./pages/3A";
import BurninRubber5A from "./pages/5A";
import Donations from "./pages/Donations";
import BR5ALeaderboards from "./pages/leaderboards/5A";
import EOSL from "./pages/EOSL";
import IgnitionLeaderboards from "./pages/leaderboards/Ignition";
import UnchainedLeaderboards from "./pages/leaderboards/Unchained";
import LeaderboardsIndex from "./pages/LeaderboardsIndex";
import { globalAllowLeaderboards } from ".";


function App() {
  const getDb = async () =>{
    try {
        await fetch("https://autoworks-server.vercel.app/check-db-connection");
    } catch (error) {
            console.error("Failed to fetch:", error.message);
        return null;
    }
}
  getDb();

  return (
    <BrowserRouter>
      <NavBar/>
      <Routes>
        <Route path="/" element={<Home/>}/>
        <Route path="/nitrostream" element={<NitroStream/>}/>
        <Route path="/sabotage" element={<NitroStream2/>}/>
        <Route path="/sideattack" element={<Sideattack/>}/>
        <Route path="/3a" element={<BurninRubber3A/>}/>
        <Route path="/5a" element={<BurninRubber5A/>}/>
        <Route path="/nitrostream3" element={<NitroStreamIgnition/>}/>
        <Route path="/ignition" element={<NitroStreamIgnition/>}/>
        {/* leaderboards */}
        
        {globalAllowLeaderboards && (
          <>
            <Route path="/leaderboards" element={<LeaderboardsIndex />} />
            <Route path="/5a/leaderboards" element={<BR5ALeaderboards />} />
            <Route path="/ignition/leaderboards" element={<IgnitionLeaderboards />} />
            <Route path="/unchained/leaderboards" element={<UnchainedLeaderboards />} />
          </>
        )}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
